import { Alert, Box, Grid } from "@mui/material";
import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import { Agendar } from "./Agendar";
import { useList } from "../useList";
import AgendamentoList from "../../Agendamento/List";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckIcon from "@material-ui/icons/CheckCircle";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { LoadingButton } from "../../../components/Loading";
import { Cancelar } from "../Cancelar";
import { useInit } from "../../Router/InitContext";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { ProfissionalSetor } from "../../ProfissionalSetor/ProfissionalSetor";
import { useAuth } from "../../Auth/AuthContext";

export function Agendamentos() {
  const {
    setorAtendimentoFromUser,
    profissionais,
    isLoading: isLoadingInit,
  } = useInit();
  const { user } = useAuth();

  const {
    agendamentos,
    isLoading,
    loadMore,
    hasMore,
    load,
    setSetorAtendimento,
    setorAtendimento,
    profissional,
    setProfissional,
  } = useList({
    isAgendamento: true,
    initialProfissional: profissionais.find((p) => p.user?.id === user.user.id),
    initialSetorAtendimento: setorAtendimentoFromUser,
    enabled: !isLoadingInit,
  });

  const [openedPanel, setOpenedPanel] = useState(2);
  const [agendamentoId, setAgendamentoId] = useState(undefined);
  const [agendamentoIdToCancel, setAgendamentoIdToCancel] = useState(undefined);

  return (
    <>
      <Accordion
        expanded={openedPanel === 1}
        onChange={() => setOpenedPanel(1)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography sx={{ fontWeight: "bold" }}>
            {agendamentoId ? "Editar" : "Novo"} Agendamento
          </Typography>
        </AccordionSummary>
        <Agendar
          agendamentoId={agendamentoId}
          onClose={(data) => {
            setOpenedPanel(2);
            setAgendamentoId(undefined);
            if (data) load();
          }}
        />
      </Accordion>
      <Accordion
        expanded={openedPanel === 2}
        onChange={() => setOpenedPanel(2)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <Typography sx={{ fontWeight: "bold" }}>
            Agendamentos Cadastrados
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container mb={2} spacing={2}>
            <ProfissionalSetor
              gridSetorProps={{ xs: 12, sm: 6, lg: 4 }}
              textFieldSetorProps={{
                label: "Filtro por setor",
              }}
              textFieldProfissionalProps={{
                label: "Filtro por profissional",
              }}
              gridProfissionalProps={{ xs: 12, sm: 6, lg: 4 }}
              setorAtendimento={setorAtendimento || ""}
              onChangeSetor={(e, setorAtendimento) =>
                setSetorAtendimento(setorAtendimento)
              }
              profissional={profissional}
              onChangeProfissional={(e, profissional) =>
                setProfissional(profissional)
              }
            />
          </Grid>
          {isLoading || isLoadingInit ? (
            <LinearProgress />
          ) : agendamentos.length > 0 ? (
            <AgendamentoList
              agendamentos={agendamentos}
              bulkActions={(a) => (
                <ActionBox>
                  <Typography variant="body2">
                    <b>{a.length} </b>
                    {a.length === 1
                      ? "atendimento selecionado"
                      : "atendimentos selecionados"}
                  </Typography>
                  <Button
                    color="secondary"
                    variant="contained"
                    startIcon={<CancelIcon />}
                    title="Cancelar todos atendimentos selecionados"
                    onClick={() => {}}
                  >
                    Cancelar selecionados
                  </Button>
                </ActionBox>
              )}
              actions={(a) => (
                <>
                  <Tooltip title="Iniciar atendimento em grupo">
                    <IconButton
                      component={Link}
                      to={`/grupo/atendimento/${a.id}`}
                      color="info"
                    >
                      <CheckIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Editar agendamento">
                    <IconButton
                      onClick={() => {
                        setOpenedPanel(1);
                        setAgendamentoId(a.id);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Cancelar agendamento">
                    <IconButton
                      color="error"
                      onClick={() => setAgendamentoIdToCancel(a.id)}
                    >
                      <CancelIcon />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            />
          ) : (
            <Alert severity="info">
              Nenhum agendamento cadastrado
              {setorAtendimento ? ` para o setor ${setorAtendimento.nome}` : ""}
            </Alert>
          )}

          {hasMore && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <LoadingButton
                onClick={loadMore}
                variant="text"
                color="primary"
                loading={isLoading}
              >
                Carregar mais ...
              </LoadingButton>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
      {agendamentoIdToCancel && (
        <Cancelar
          agendamentoId={agendamentoIdToCancel}
          onClose={(data) => {
            setAgendamentoIdToCancel(undefined);
            if (data) load();
          }}
        />
      )}
    </>
  );
}

const ActionBox = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1),
  justifyContent: "space-between",
  alignItems: "center",
  bottom: 0,
  position: "sticky",
  zIndex: 1,
}));
